import { A2APayment, CardPayment, PaymentMethodType } from '@nemuru-eng/js-api-client';

import { SinglePaymentDataDisplay } from '@/components/modules/SinglePayment/_shared/components/SinglePaymentDataDisplay';
import { getCardHeaderParamsBySinglePaymentType } from '@/components/modules/SinglePayment/_shared/utils/getCardHeaderParamsBySinglePaymentType';
import { ConditionsSummaryWrapper } from '@/components/shared/components/ConditionsSummary/_shared/ConditionsSummaryWrapper';

interface CardPaymentConditionsSummary {
  singlePayment: CardPayment | A2APayment;
  paymentMethodType: PaymentMethodType.A2A_PAYMENT | PaymentMethodType.CARD_PAYMENT;
}

export const SinglePaymentConditionsSummary = ({ singlePayment, paymentMethodType }: CardPaymentConditionsSummary) => {
  const CustomCardHeaderParams = getCardHeaderParamsBySinglePaymentType(paymentMethodType);
  if (!CustomCardHeaderParams) return null;
  return (
    <>
      <ConditionsSummaryWrapper
        title={CustomCardHeaderParams.title}
        surtitle={CustomCardHeaderParams.surtitle}
        iconName={CustomCardHeaderParams.iconName}
        id={singlePayment.id}
        principal={singlePayment.principal}
      >
        <SinglePaymentDataDisplay singlePaymentDetails={singlePayment} />
      </ConditionsSummaryWrapper>
    </>
  );
};
